import axios from "axios";
import {URLAPISUBIDA, URLCARPETADESTINO} from "./Contantes";

export const subirImagenHostingFile = (file) => {


    return new Promise(resolve => {


        if (!file){
            return resolve({res: true, data: ''})
        }

        if (typeof file === 'string') {
            return resolve({res: true, data: file})

        } else {

            const formData = new FormData();
            formData.append('img', file);

            axios.post(URLAPISUBIDA, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    return resolve({res: true, data: URLCARPETADESTINO + response.data.file_path})
                    // Handle successful upload response
                })
                .catch(error => {
                    return resolve({res: false, data: error.message})
                });


        }
    })


}

